import styled, { css } from 'styled-components';
import BaseSearchIcon from '#/shared/components/GeneratedIcons/trimet/Search';
import { ClearButton } from '#/shared/components/Styled';

export const OmniboxButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.primaryFontColorReverse};
  justify-content: center;
`;

export const SearchIcon = styled(BaseSearchIcon).attrs(props => {
  const isCurrentLocOrFavorites = props.$currentLocOrFavorites;
  const fillColor = isCurrentLocOrFavorites
    ? props.theme.primaryFontColor
    : props.theme.primaryFontColorReverse;
  const size = isCurrentLocOrFavorites ? 15 : 20;

  return {
    fill: fillColor,
    width: size,
    height: size,
  };
})`
  margin-right: 8px;
`;

/** TODO: Have this button use the Button component
 * https://trimet.atlassian.net/browse/PUBWEB-1790
 */

export const OmniButton = styled(ClearButton)`
  display: flex;
  flex: 1 0 auto;
  align-items: center;
  width: 100%;
  justify-content: center;
  background-color: transparent;
  border-radius: ${props => props.theme.buttonRounded};
  ${({ $currentLocOrFavorites }) =>
    $currentLocOrFavorites
      ? css`
          font-size: 1rem;
          padding: 4px 16px;
          border: 2px solid ${props => props.theme.primaryFontColor};
          color: ${props => props.theme.primaryFontColor};
          &:hover,
          &:active,
          &:focus {
            background-color: ${props => props.theme.activeColor};
          }
          &:hover ${SearchIcon} {
            fill: ${props => props.theme.primaryFontColor};
          }
        `
      : css`
          font-size: 1.2rem;
          padding: 8px 12px;
          border: 2px solid ${props => props.theme.white_50};
          color: ${props => props.theme.white};
          &:hover,
          &:active,
          &:focus {
            background-color: ${props => props.theme.white_15};
          }
          &:hover ${SearchIcon} {
            fill: ${props => props.theme.primaryFontColorReverse};
          }
        `};
`;
